module.exports = __webpack_public_path__ + "img/vertical-logo-pink-sg.329dd79c.svg";